export default {
    namespaced:true,
    state:{
        gisScheme: null, // 地块颜色设置
        pipelineColors: {}, // 管线颜色
        authEdit: false, // 总表是否可编辑
        planningMapMenu: '0', // 规划蓝图子菜单
        showPmPanoEdit: false, // 显示规划蓝图全景图编辑框
        showPmPanoPreview: false, // 显示规划蓝图全景图预览框
        selectedPmPointMarker: null, // 规划蓝图-本期规划当前选中点位标签(id或者坐标)
        pmPointMarkerList: [] // 规划蓝图-本期规划点位列表
    },
    mutations:{
        setGisScheme(state, payload) {
            state.gisScheme = payload
        },
        setPipelineColors(state, payload) {
            state.pipelineColors = payload
        },
        setAuthEdit(state, payload ) {
            state.authEdit = payload
        },
        setPlanningMapMenu(state, payload) {
            state.planningMapMenu = payload
        },
        setPlanningMapPano(state, payload) {
            state.showPmPanoEdit = payload.showPmPanoEdit
            state.showPmPanoPreview = payload.showPmPanoPreview
        },
        setSelectedPmPointMarker(state, payload) {
            state.selectedPmPointMarker = payload
        },
        setPmPointMarkerList(state, payload) {
            state.pmPointMarkerList = payload
        }
    },
    actions:{
        setGisSchemeAsync( {commit}, payload ) {
            commit( 'setGisScheme', payload );
        },
        setPipelineColorsAsync( {commit}, payload ) {
            commit( 'setPipelineColors', payload );
        },
        setAuthEditAsync( {commit}, payload ) {
            commit( 'setAuthEdit', payload );
        },
        setPlanningMapMenuAsync( {commit}, payload ) {
            commit( 'setPlanningMapMenu', payload );
        },
        setPlanningMapPanoAsync( {commit}, payload ) {
            commit( 'setPlanningMapPano', payload );
        },
        setSelectedPmPointMarkerAsync( {commit}, payload ) {
            commit( 'setSelectedPmPointMarker', payload );
        },
        setPmPointMarkerListAsync( {commit}, payload ) {
            commit( 'setPmPointMarkerList', payload );
        }
    }
}